class ApiServices {
    _apiBase = process.env.NODE_ENV === 'production' ? '/menu/api/' :'http://cocktail/delivery-app/api/';

    getResource = async (url, params = null) => {
        const res = await fetch(url, params);
    
        console.log(res);
        if (!res.ok) {
            throw new Error("Not Found");
        }
        console.log(res);
        return await res.json();
    }

    getCategorires = async () => {
        const res = await this.getResource(`${this._apiBase}categories`);
        return await res;
    }

    getProductsByCategories = async () => {
        const res = await this.getResource(`${this._apiBase}products`);
        return await res;
    }

    showMoreProducts = async (id, offset) => {
        const res = await this.getResource(`${this._apiBase}load-more/${id}/${offset}`);
        return await res;
    }

    getProductsById = async (id) => {
        const res = await this.getResource(`${this._apiBase}product/${id}`);
        return await res;
    }
    

    getCart = async (data) => {      
        if (data.length === 0)
        {
            return []
        }

        const res = await this.getResource(`${this._apiBase}cart`,{
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                data: data,
            })
        })
        return await res;
    }

    getSearchResult = async (query) => {
        if(query.trim().length === 0) {
            return []
        }

        const res = await this.getResource(`${this._apiBase}search/${query}`);

        return await res;
    }

    getAboutCompany = async () => {
        const res = await this.getResource(`${this._apiBase}about-info`);

        return await res;
    }

    getLiqPayData = async (data) => {
        const res = await this.getResource(`${this._apiBase}liqpay`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        });

        return await res;
    }

    createOrder = async () => {
        const cart = JSON.parse(localStorage.getItem('cart'));
        const shipping = JSON.parse(localStorage.getItem('shipping'));
        const payment = localStorage.getItem('payment');

        const res = await this.getResource(`${this._apiBase}create-order`,{
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                cart: cart,
                shipping: shipping,
                payment: payment,
            })
        });

        return await res;
    }

    getHistory = async (param = null) => {

        const query = param !== null ? `/${param}` : '';

        const res = await this.getResource(`${this._apiBase}history${query}`)

        return await res;
    }
}

export default ApiServices;